import { ImagesKeys } from '../types/store.types'

export const mapImagesKeys: Record<string, ImagesKeys> = {
  install: 'installImages',
  impossible: 'impossibleImages',
  uncompleted: 'uncompletedImages',
  clarify: 'clarificationImages',
  'accepted-to-impossible-dealer-action': 'impossibleImages',
  'working-to-impossible-dealer-action': 'impossibleImages',
  reportedEdit: 'reportedEditImages',
}

export const imagesKeys: ImagesKeys[] = [
  'installImages',
  'impossibleImages',
  'uncompletedImages',
  'clarificationImages',
  'reportedEditImages',
]

type SubscriberInfoType = Record<string, string>

export const subscriberInfo: SubscriberInfoType = {
  Surname: 'Фамилия: ',
  Name: 'Имя: ',
  Patronymic: 'Отчество: ',
  Phone: 'Номер телефона: ',
  PhoneNumber: 'Номер телефона: ',
  Territory: 'Регион: ',
  District: 'МО\\ГО: ',
  Locality: 'Населённый пункт: ',
  AddressType: 'Топоним адреса: ',
  Address: 'Улица: ',
  House: 'Номер дома: ',
  Building: 'Корпус: ',
  Apartment: 'Квартира: ',
  Reason: 'Причина установки: ',
  PreferentialCategory: 'Льготная категория (легаси): ',
  AdditionalInfo: 'Доп инфа легаси: ',
  equipmentId: 'id оборудования: ',
  SenderId: 'Источник: ',
  Installed: 'Дата установки: ',
  installed: 'Дата установки: ',
  Categories: 'Льготные категории: ',
}

export const addressKeys = [
  'Territory',
  'District',
  'Locality',
  'AddressType',
  'Address',
  'House',
  'Building',
  'Apartment',
]
